module.exports = __webpack_public_path__ + "img/Apt.57436c88.png";